import React from 'react';
import ParkingSpotInfoHeader from './ParkingSpotInfoHeader';
import ParkingSpotInfoDetail from './ParkingSpotInfoDetail';

const PointOfInterestInfo = ({ pointsOfInterest }) => {
  const {spotId, location, size, surface} = pointsOfInterest;

  return (
    <div className="map-infobar__spot" >
      <ParkingSpotInfoHeader spotId={spotId} location={location} size={size} surface={surface} />
      <ParkingSpotInfoDetail attendees={[]} />
    </div>
  );
};

export default PointOfInterestInfo;



// WEBPACK FOOTER //
// ./src/components/MapInfoBar/PointOfInterestInfo.js